import React from 'react'
import Dashboard from './Dashboard'
import {
	InstrumentManagement, InstrumentAdjustManagement, InstrumentCheckManagement, InstrumentMaintainManagement,
	InstrumentRepairApply, InstrumentFaultConfirm, InstrumentRepairHandle, RepairResultConfirm, RepairRecordUpload, InstrumentRepairQuery,
	OperationRuleEdit, OperationRuleApprove, OperationRuleQuery,
} from './Instrument/index'
import {
	QualityFileManagement, DocumentApproval, Documentation, DocumentReview, DraftQuery,
	AmendmentApplication, RevisionApproval, RevisionQuery, RevisionReview,
	DestroyQuery, DestructionApplication, DestructionApproval, DocumentDestruction, DestructionAudit
} from './QualityFileManagement/index'
import { SysSettings } from './SysManage'
import Tyanlims from './TyanLims'
import ChangePassword from './ChangePassword'
import Logout from '../business/Logout'

// 选择图标 => https://fontawesome.com/cheatsheet?from=io

export default {
	主页: { _icon: "home", _path: "/Tyanlims/UCAuthMain", _component: Tyanlims },
	业务管理: {
		_icon: "bars",
		委外管理: { _icon: "files-o", _path: "/Tyanlims/UCDynamicMenu67", _component: Tyanlims, },
		委托申请: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu54", _component: Tyanlims, },
		委托评审: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu69", _component: Tyanlims, },
		报价编制: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu114", _component: Tyanlims, },
		费用申请: { _icon: "file-text-o", _path: "/Tyanlims/UCDynamicMenu115", _component: Tyanlims, },
		委托报价: { _icon: "file-o", _path: "/Tyanlims/UCDynamicMenu56", _component: Tyanlims, },
		排工审核: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu110", _component: Tyanlims, },
		数据引用审批: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu104", _component: Tyanlims, },
		委托总评审: { _icon: "check-square-o", _path: "/Tyanlims/UCDynamicMenu78", _component: Tyanlims, },
		委托变更修改: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu103", _component: Tyanlims, },
	},
	样品管理: {
		_icon: "bars",
		样品库存管理: { _icon: "cubes", _path: "/Tyanlims/UCDynamicMenu11", _component: Tyanlims, },
		样品信息管理: {
			_icon: "bars",
			接头角度: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu87", _component: Tyanlims, },
			接头锁扣颜色: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu88", _component: Tyanlims, },
			接头规格型号: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu89", _component: Tyanlims, },
			结构材料: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu90", _component: Tyanlims, },
			总成管段规格型号: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu91", _component: Tyanlims, },
			样品分类: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu92", _component: Tyanlims, },
		},
	},
	日常管理: {
		_icon: "bars",
		日常任务: { _icon: "tasks", _path: "/Tyanlims/UCDynamicMenu93", _component: Tyanlims, },
	},
	检测管理: {
		_icon: "bars",
		任务分工: { _icon: "share-alt", _path: "/Tyanlims/UCInspectionDivideManagerPage", _component: Tyanlims, },
		更换主检人: { _icon: "retweet", _path: "/Tyanlims/UCDynamicMenu74", _component: Tyanlims, },
		出入厂测试: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu65", _component: Tyanlims, },
		任务待排工: { _icon: "calendar-plus-o", _path: "/Tyanlims/UCDynamicMenu58", _component: Tyanlims, },
		任务已排工: { _icon: "calendar-check-o", _path: "/Tyanlims/UCDynamicMenu86", _component: Tyanlims, },
		检测计划: { _icon: "calendar", _path: "/Tyanlims/UCDynamicMenu15", _component: Tyanlims, },
		人员计划: { _icon: "calendar", _path: "/Tyanlims/UCDynamicMenu116", _component: Tyanlims, },
		设备运行图: { _icon: "tasks", _path: "/Tyanlims/UCInspectionPlanViewPage", _component: Tyanlims, },
		人员计划图: { _icon: "tasks", _path: "/Tyanlims/UCPersonInspectionPlanViewPage", _component: Tyanlims, },
		数据审核: { _icon: "check", _path: "/Tyanlims/UCInspectionAuditManagePage", _component: Tyanlims, },
		数据撤回: { _icon: "reply", _path: "/Tyanlims/UCInspectSampleWithDrawManagerPage", _component: Tyanlims, },
		原始记录导出: { _icon: "reply", _path: "/Tyanlims/UCDynamicMenu96", _component: Tyanlims, },
	},
	报告管理: {
		_icon: "bars",
		报告编制: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu84", _component: Tyanlims, },
		报告审核: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu63", _component: Tyanlims, },
		报告批准: { _icon: "check-square-o", _path: "/Tyanlims/UCDynamicMenu64", _component: Tyanlims, },
		报告撤回: { _icon: "reply", _path: "/Tyanlims/UCReportWithDrawManagerPage", _component: Tyanlims, },
		报告制作: { _icon: "file-pdf-o", _path: "/Tyanlims/UCReportDoManagerPage", _component: Tyanlims, },
		报告领取: { _icon: "paper-plane-o", _path: "/Tyanlims/UCReportTakeManagerPage", _component: Tyanlims, },
		合并报告: { _icon: "code-fork", _path: "/Tyanlims/UCDynamicMenu60", _component: Tyanlims, },
		报告邮件发送: { _icon: "envelope-o", _path: "/Tyanlims/UCDynamicMenu73", _component: Tyanlims, },
	},
	委外管理: {
		_icon: "bars",
		委外登记: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu79", _component: Tyanlims, },
		委外评审: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu80", _component: Tyanlims, },
		委外费用申请: { _icon: "file-text-o", _path: "/Tyanlims/UCDynamicMenu81", _component: Tyanlims, },
		委外分工: { _icon: "share-alt", _path: "/Tyanlims/UCDynamicMenu82", _component: Tyanlims, },
		委外报告上传: { _icon: "upload ", _path: "/Tyanlims/UCDynamicMenu83", _component: Tyanlims, },
	},
	数据查询: {
		_icon: "search",
		合同查询: { _icon: "search", _path: "/Tyanlims/UCDynamicMenu59", _component: Tyanlims, },
		样品查询: { _icon: "search", _path: "/Tyanlims/UCQuerySampleManagerPage", _component: Tyanlims, },
		报告查询: { _icon: "search", _path: "/Tyanlims/UCQueryReportManagerPage", _component: Tyanlims, },
		合同进度查询: { _icon: "search", _path: "/Tyanlims/UCDynamicMenu85", _component: Tyanlims, },
		项目查询: { _icon: "search", _path: "/Tyanlims/UCQuerySampleInspectionManagerPage", _component: Tyanlims, },
		计划查询: { _icon: "search", _path: "/Tyanlims/UCDynamicMenu27", _component: Tyanlims, },
	},
	标准管理: {
		_icon: "database",
		标准制定: { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu75", _component: Tyanlims, },
		标准审核: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu76", _component: Tyanlims, },
		标准批准: { _icon: "check-square-o ", _path: "/Tyanlims/UCDynamicMenu77", _component: Tyanlims, },
		标准管理: { _icon: "database", _path: "/Tyanlims/UCInspectionManagePage", _component: Tyanlims, },
		'标准/单位管理': { _icon: "edit", _path: "/Tyanlims/UCDynamicMenu95", _component: Tyanlims, },
	},
	实验室管理: {
		_icon: "bank",
		人员管理: { _icon: "user", _path: "/Tyanlims/UCPersonManagerPage", _component: Tyanlims, },
		消耗品管理: { _icon: "cubes", _path: "/Tyanlims/UCConsumableMangerPage", _component: Tyanlims, },
		显示屏分类管理: { _icon: "window-restore", _path: "/Tyanlims/UCScreenGenreManagerPage", _component: Tyanlims, },
	},
	设备管理: {
		_icon: "empire",
		设备信息: { _icon: "credit-card", _path: "/InstrumentManagement", _component: InstrumentManagement, },
		设备计量: { _icon: "crosshairs", _path: "/InstrumentAdjustManagement", _component: InstrumentAdjustManagement, },
		设备期间核查: { _icon: "binoculars", _path: "/InstrumentCheckManagement", _component: InstrumentCheckManagement, },
		设备维护保养: { _icon: "life-ring", _path: "/InstrumentMaintainManagement", _component: InstrumentMaintainManagement, },
		设备维修: {
			_icon: "wrench",
			维修申请: { _icon: "edit", _path: "/InstrumentRepairApply", _component: InstrumentRepairApply, },
			故障确认: { _icon: "facebook-f", _path: "/InstrumentFaultConfirm", _component: InstrumentFaultConfirm, },
			设备维修: { _icon: "cog", _path: "/InstrumentRepairHandle", _component: InstrumentRepairHandle, },
			结果确认: { _icon: "check-square-o", _path: "/RepairResultConfirm", _component: RepairResultConfirm, },
			记录上传: { _icon: "upload", _path: "/RepairRecordUpload", _component: RepairRecordUpload, },
			维修查询: { _icon: "search", _path: "/InstrumentRepairQuery", _component: InstrumentRepairQuery, },
		},
		安全操作规程: {
			_icon: "registered",
			操作规程编写: { _icon: "edit", _path: "/OperationRuleEdit", _component: OperationRuleEdit, },
			操作规程审批: { _icon: "check-square-o", _path: "/OperationRuleApprove", _component: OperationRuleApprove, },
			操作规程查询: { _icon: "search", _path: "/OperationRuleQuery", _component: OperationRuleQuery, },
		},

	},
	体系管理: {
		_icon: "book",
		体系文件管理: { _icon: "book", _path: "/QualityFileManagement", _component: QualityFileManagement, },
		体系文件起草: {
			_icon: "edit",
			文件编制: { _icon: "edit", _path: "/Documentation", _component: Documentation, },
			文件审核: { _icon: "check-square", _path: "/DocumentReview", _component: DocumentReview, },
			文件批准: { _icon: "check-square-o", _path: "/DocumentApproval", _component: DocumentApproval, },
			起草查询: { _icon: "search", _path: "/DraftQuery", _component: DraftQuery, },
		},
		体系文件修订: {
			_icon: "edit",
			修订申请: { _icon: "edit", _path: "/AmendmentApplication", _component: AmendmentApplication, },
			修订审核: { _icon: "check-square", _path: "/RevisionReview", _component: RevisionReview, },
			修订批准: { _icon: "check-square-o", _path: "/RevisionApproval", _component: RevisionApproval, },
			修订查询: { _icon: "search", _path: "/RevisionQuery", _component: RevisionQuery, },
		},
		体系文件销毁: {
			_icon: "ban",
			销毁申请: { _icon: "edit", _path: "/DestructionApplication", _component: DestructionApplication, },
			销毁审核: { _icon: "check-square", _path: "/DestructionAudit", _component: DestructionAudit, },
			销毁批准: { _icon: "check-square-o", _path: "/DestructionApproval", _component: DestructionApproval, },
			文件销毁: { _icon: "ban", _path: "/DocumentDestruction", _component: DocumentDestruction, },
			销毁查询: { _icon: "search", _path: "/DestroyQuery", _component: DestroyQuery, },
		},
	},
	项目费用管理: {
		_icon: "bars",
		项目费用管理: { _icon: "bars", _path: "/Tyanlims/UCDynamicMenu105", _component: Tyanlims, },
		项目费用审批: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu106", _component: Tyanlims, },
		项目费用使用审批: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu107", _component: Tyanlims, },
		项目续费审批: { _icon: "check", _path: "/Tyanlims/UCDynamicMenu108", _component: Tyanlims, },
	},
	报表管理: {
		_icon: "line-chart",
		数据统计: { _icon: "line-chart", _path: "/Tyanlims/UCSheetGenManagerPage", _component: Tyanlims, },
	},
	系统管理: {
		_icon: "cogs",
		系统参数: { _icon: "cog", _path: "/Settings", _component: SysSettings, },
	},
	修改密码: { _icon: "key", _path: "/ChangePassword", _component: ChangePassword, _public: true, },
	注销: { _icon: "sign-out", _path: "/Logout", _component: Logout, _public: true, },
}